import { render, staticRenderFns } from "./DSTypography.vue?vue&type=template&id=9cc5c248&"
import script from "./DSTypography.vue?vue&type=script&lang=js&"
export * from "./DSTypography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports